import React from "react";
import PropertyBase, { IBasePropertyProps } from "./PropertyBase";
import AnalyticsManager from "../../classes/AnalyticsManager";

interface IBoolPropertyProps extends IBasePropertyProps
{
	radioStyle?: boolean;
}

export default function BoolProperty(props: IBoolPropertyProps)
{
	const faceValue = (props.multivalues !== undefined) ? props.value || props.multivalues : props.value;
	const dataName = (props["data-name"] ? props["data-name"] + "-" : "") + "-bool-property";

	return (
		<PropertyBase {...props}
			data-name={dataName + "-root"}
		>
			<input
				data-name={dataName + "-input"}
				className={[
					"checkboxField",
					(props.radioStyle ? "radioButtonCheckboxField" : ""),
					(props.multivalues ? "multivalue" : ""),
					props.className,
				].join(' ')}
				type="checkbox"
				checked={faceValue === 'true' || faceValue === true ? true : false}
				disabled={props.disabled}
				onChange={(e) =>
				{
					AnalyticsManager.managedEvent('propertyChanged', 'propertyId', e.target.dataset.name)

					if (props.onCommitCallback)
					{
						props.onCommitCallback(e.currentTarget.checked);
					}
					else if (props.onChangeCallback)
					{
						props.onChangeCallback(e.currentTarget.checked);
					}

					e.target.blur();
				}}
			/>
		</PropertyBase>
	);
}
